// components/Menu/parts/SortPanel.jsx
import { useRef, useMemo } from "react";
import { useMenu } from "../context/MenuContext";
import { useFloatingVerticalPosition } from "../../../hooks/useFloatingVerticalPosition";
import { useAutoClosePanel } from "../../../hooks/useAutoClosePanel";
//import { getChronologyPeriods } from "../../../utils/enrichImageData";
import "./SortPanelLight.css"; // optionnel si tu veux isoler
import {
  //ArrowUpAZ,
  //ArrowUpZA,
  ArrowUp01,
  ArrowDown01,
  // Shuffle,
} from "lucide-react";
//ArrowDownAZ,ArrowDown01,
//import { HiCodeBracketSquare } from "react-icons/hi2";
//import { FaArrowsLeftRightToLine } from "react-icons/fa6";
//import { GoArrowBoth } from "react-icons/go";
import { GoDot, GoDotFill } from "react-icons/go";

const SortPanel = ({
  /*menuRef,*/ isOpen = true,
  left,
  triBtnRef,
  onClose,
}) => {
  const {
    /*sortNomActive,
    sortNomAsc,
    toggleSortNom,

    sortAdresseActive,
    sortAdresseAsc,
    toggleSortAdresse,*/

    sortDateActive,
    sortDateAsc,
    toggleSortDate,

    /*resetSort,
    shuffle,*/

    selectedPeriod,
    setPeriod,
    periods,

    viewMode,
  } = useMenu();

  const panelRef = useRef(null);

  /* --------------------------------------------------
     Ajustement vertical (éviter overflow viewport)
  -------------------------------------------------- */
  const top = useFloatingVerticalPosition({
    anchorRef: triBtnRef,
    panelRef,
    align: "bottom",
    offset: 4,
  });

  /* --------------------------------------------------
     Fermeture auto (inactivité)
     Fermeture clic extérieur / scroll / resize
  -------------------------------------------------- */
  useAutoClosePanel({
    isOpen,
    panelRef,
    onClose,
    timeout: 5000,
  });

  /* --------------------------------------------------
     Pour le tri
  -------------------------------------------------- */
  // const periods = getChronologyPeriods();
  //console.log("PERIODS →", getChronologyPeriods());

  // transformation en objets numériques
  const ranges = useMemo(() => {
    return periods.map((p) => {
      const [startStr, endStr] = p.period.split("-");
      return {
        label: p.label,
        start: parseInt(startStr, 10),
        end: parseInt(endStr, 10),
      };
    });
  }, [periods]);
  /*
  // 🔴 ICI → définition de globalRange
  const { //globalStart, globalEnd,// globalRange } = useMemo(() => {
    if (ranges.length === 0) {
      return { globalStart: 0, globalEnd: 0, globalRange: 1 };
    }

    const starts = ranges.map((r) => r.start);
    const ends = ranges.map((r) => r.end);

    const min = Math.min(...starts);
    const max = Math.max(...ends);

    return {
      globalStart: min,
      globalEnd: max,
      globalRange: max - min || 1,
    };
  }, [ranges]);
*/
  const isActivePeriod = (range) => {
    if (!selectedPeriod) return false;
    return (
      selectedPeriod.start === range.start && selectedPeriod.end === range.end
    );
  };

  /* --------------------------------------------------
     Render
  -------------------------------------------------- */
  return (
    <div
      ref={panelRef}
      className="sort-panel"
      style={{ left, top }}
      //style={{ left, top: adjustedTop }}
    >
      {/* TRI PAR NOM */}
      {/* TRI PAR RUE */}
      {/* TRI PAR DATE */}
      {viewMode === "grid" && <button
        className={`sort-btn ${sortDateActive ? "active" : ""}`}
        onClick={toggleSortDate}
        type="button"
      >
        {/*<ArrowDown01
          size={16}
          className={`sort-icon ${sortDateAsc ? "asc" : "desc"}`}
        />*/}
        {sortDateAsc ? <ArrowDown01 size={16} /> : <ArrowUp01 size={16} />}
        <span className="sort-label">date</span>
      </button>}

      {/* SÉPARATEUR VISUEL (optionnel) 
      <div className="sort-panel-separator" />*/}

      {
        /*sortDateActive &&*/
        ranges.map((range) => {
          return (
            <button
              key={range.label}
              className={`chrono-period-btn ${
                isActivePeriod(range) ? "active" : ""
              }`}
              onClick={() =>
                setPeriod(
                  !isActivePeriod(range)
                    ? {
                        start: range.start,
                        end: range.end,
                      }
                    : null,
                )
              }
            >{isActivePeriod(range) ? (
                <GoDotFill size={16} />
              ) : (
                <GoDot size={16} />
              )/**/}
              <span className="chrono-period-label">{range.label}</span>
              
            </button>
          );
        })
      }

      {/* ANTI-TRI */}
    </div>
  );
};

export default SortPanel;
